/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './_routes/__root'
import { Route as IndexRouteImport } from './_routes/index'
import { Route as QuestionGeneratorIndexRouteImport } from './_routes/question-generator/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionGeneratorIndexRoute = QuestionGeneratorIndexRouteImport.update({
  id: '/question-generator/',
  path: '/question-generator/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/question-generator/': typeof QuestionGeneratorIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/question-generator': typeof QuestionGeneratorIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/question-generator/': typeof QuestionGeneratorIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/question-generator/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/question-generator'
  id: '__root__' | '/' | '/question-generator/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  QuestionGeneratorIndexRoute: typeof QuestionGeneratorIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/question-generator/': {
      id: '/question-generator/'
      path: '/question-generator'
      fullPath: '/question-generator/'
      preLoaderRoute: typeof QuestionGeneratorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  QuestionGeneratorIndexRoute: QuestionGeneratorIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
